var loc_filters_flag = false;

let checkFiltersAbility = function() {
    var page_view = jQ('form[name="housing_filter"]  #map', window.parent.document).is(':checked') ? 'map' : 'list';

    var l_id = ~~jQ('form[name="housing_filter"] input[name="location_id"]', window.parent.document).val();
    var l_type = ~~jQ('form[name="housing_filter"] input[name="location_type"]', window.parent.document).val();
    var loc_filters = false;

    if (l_type != 1) {
        jQ('#distance_filter .f-lock', window.parent.document).show();
        jQ('#label_categ_4', window.parent.document).hide();
    } else {
        jQ('#distance_filter .f-lock', window.parent.document).hide();
        jQ('#label_categ_4', window.parent.document).show();
    }

    if (!l_id && page_view == 'map')
        loc_filters = true;

    if (loc_filters == loc_filters_flag)
        return false;

    if (loc_filters) {
        jQ('.map_page .map-control').hide();
        jQ('#map-notifi-to-start').show();
        jQ('#smarter_search, #more_btn', window.parent.document).hide();
        jQ('.f-lock', window.parent.document).show();
    } else {
        jQ('.map_page .map-control').show();
        jQ('#map-notifi-to-start').hide();
        jQ('#smarter_search, #more_btn', window.parent.document).show();
        jQ('.f-lock', window.parent.document).hide();
    }

    loc_filters_flag = loc_filters;
};

export default checkFiltersAbility;
